import React from "react";

interface ISocialTwitterIconProps {
    onClick(): void;
}

export const SocialTwitterIcon = ({onClick = () => {}}: ISocialTwitterIconProps) => (
    <i className="icon ion-social-twitter-outline" onClick={onClick} />
);
